import {
  MAX_PORTRAIT_UPLOAD_BYTES,
  PortraitUploadContentType,
} from "tng-address-collection-shared/types/portraitsApiTypes.ts";

export type PhotoProblem = "unsupportedPhoto" | "photoTooLarge";

// S3 refuses these anyway, but only after the whole file went up
export const checkPhoto = (photo: File): PhotoProblem | undefined => {
  if (!PortraitUploadContentType.safeParse(photo.type).success) {
    return "unsupportedPhoto";
  }
  if (photo.size > MAX_PORTRAIT_UPLOAD_BYTES) {
    return "photoTooLarge";
  }
  return undefined;
};
